/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Intro_TitleInputs */



/**
* | output |
* | --- |
* | "Your team, based on your calendar" |
*
* @param {Team_Intro_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_intro_title = /** @type {((inputs?: Team_Intro_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Intro_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je team, op basis van je agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre équipe, d'après votre agenda")
	return /** @type {LocalizedString} */ ("Your team, based on your calendar")
});